import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { RadioControl } from '../../../models/form/FormControlRadio';
import { createControl } from '../../../utilities/formUtilities';
import { Store } from '@ngrx/store';
import { selectIsCreateStandingAuth } from 'projects/money-movement-ui/src/app/shared/reducers';
import { FeatureFlagService } from 'projects/money-movement-ui/src/app/shared/services/feature-flag-service';
import { CheckTransactionDetailsForm } from '../../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-check-recipient',
  templateUrl: './check-recipient.component.html',
  styleUrls: ['./check-recipient.component.scss']
})
export class CheckRecipientComponent implements OnInit {
  @Input() parentForm!: FormGroup<CheckTransactionDetailsForm>;
  @Input() isFirstPartyModified: boolean;
  @Input() recipientAddressType: string;
  @Input() isFromEditTable: boolean;
  @Input() shouldDisableFieldForEditQcd: boolean = false;
  private readonly controlNames = {
    recpient: 'recipient'
  };
  recipientModel: RadioControl = {
    title: 'Delivery address',
    controlName: this.controlNames.recpient,
    radios: [
      {
        value: 'firstParty',
        label: ['Account holder address'],
      },
      {
        value: 'advisoryFirm',
        label: ['Advisory firm for this account']
      },
      {
        value: 'thirdPartyDomestic',
        label: ['Other U.S. address']
      },
      {
        value: 'thirdPartyInternational',
        label: ['Other International address']
      }
    ],
    validationMessage: 'Select a delivery address'
  }
  standingAuthRecipientModel: RadioControl = {
    title: 'Delivery address',
    controlName: this.controlNames.recpient,
    radios: [
      {
        value: 'firstParty',
        label: ['Account holder address'],
      },
      {
        value: 'thirdPartyDomestic',
        label: ['Other U.S. address']
      },
      {
        value: 'thirdPartyInternational',
        label: ['Other International address']
      }
    ],
    validationMessage: 'Select a delivery address'
  }
  destroy$: Subject<boolean> = new Subject<boolean>();
  isStandingAuthPage: boolean;

  constructor(private store: Store, private ffs: FeatureFlagService) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.controlNames.recpient, '', [Validators.required], undefined, this.shouldDisableRecipient());

    this.store.select(selectIsCreateStandingAuth).pipe(takeUntil(this.destroy$)).subscribe(val => this.isStandingAuthPage = val);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  shouldDisableRecipient(): boolean {
    return (
      this.isFromEditTable &&
      this.isFirstPartyModified &&
      this.recipientAddressType === 'addressofrecord' ||
      this.shouldDisableFieldForEditQcd
    );
  }
}
